module.exports = __webpack_public_path__ + "static/media/entranceD.2b4d8f1d.jpg";